import { TextSize, Weight } from 'components'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'
import { BaseScrollStyle } from '../scrollbar/index'

export const OutlineAccountCenterContainer = styled.div<{ isBlurred: boolean }>`
  position: absolute;
  bottom: 0;
  display: ${({ isBlurred }) => (isBlurred ? 'flex' : 'none')};
  background: ${({ theme }) => theme.accountCenterBg};
  z-index: 9;
  height: calc(100% - 50px);
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Mobile`
  height: calc(100% - 60px);
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  height: calc(100% - 60px);
`}
`

/**
 * Container focuses on positioning of the account center
 */
export const StyledAccountCenterContainer = styled.div<{ show: boolean }>`
  top: 10px;
  position: absolute;
  z-index: 10;
  > * {
    letter-spacing: -0.01em;
  }
  display: ${({ show }) => (show ? 'flex' : 'none')};
  right: 0;

  ${({ theme }) => theme.mediaWidth.Desktop`
    right: calc((100% - 825px) / 2);
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    justify-content: center;
    top: 0;
    width: 100%;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    justify-content: center;
    top: 0;
    width: 100%;
  `}
`
/**
 * Styled wrapper forcuses on the base style for the account center
 */
export const StyledAccountCenterWrapper = styled.div`
  width: 516px;
  max-height: 343px;
  background-color: ${({ theme }) => theme.bg};
  box-shadow: 0px 3px 28px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.Mobile`
  width: 100%;
  border-radius: 0px;
  box-shadow: 0px 29px 38px rgb(0 0 0 / 10%);
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  width: 100%;
  border-radius: 0px;
  box-shadow: 0px 29px 38px rgb(0 0 0 / 10%);
`}
`

export const AccountCenterOuterMargins = styled.div`
  margin: 0 32px 0 34px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin: 0 32px 0 20px;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    margin: 0 32px 0 20px;
  `}
`

/**
 * Styled container for the account details section of the account center
 * @returns
 */
export const StyledAccountDetailsContainer = styled(AccountCenterOuterMargins)`
  display: flex;
  height: 60px;
  justify-content: space-between;
`

/**
 * Styled Text for the account address
 * @returns
 */
export const StyledAccountAddressText = styled.span`
  font-size: ${TextSize.four};
  color: ${({ theme }) => theme.primaryFontColor};
  font-weight: ${Weight.Medium};
`

/**
 * Styled container for the "left" side of the account details section in the account center
 * @returns
 */
export const StyledAccountDetailsLeftContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`
/**
 * Styled container for the "right" side of the account details section in the account center
 * @todo update font sizes
 */
export const StyledAccountDetailsRightContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: ${TextSize.tiny};
  gap: 6px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    padding-top: 0px;
`}
  &>div: last-child {
    span {
      direction: rtl;
      margin-left: -12px;
    }
  }
`

/**
 * Styling for the Copy container
 * @returns
 */
export const OutboundContainer = styled.div<{ showText: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 24px;
  cursor: pointer;
  position: relative;
  & > div > svg > path {
    stroke: ${({ theme, showText }) =>
      showText ? theme.primaryFontColor : theme.secondaryFontColor};
  }
  gap: 4px;
`

/**
 * Styled component for tooltip text span
 * small transition on render
 */
export const StyledSpan = styled.span<{ showText: boolean }>`
  opacity: ${({ showText }) => (showText ? '1' : '0')};
  cursor: pointer;
`

/**
 * Structural container for the transaction list
 */
export const TransactionListsWrapper = styled(BaseScrollStyle)`
  margin: 0 7.5px 10px 15px;
  max-height: 270px;
  ${({ theme }) => theme.mediaWidth.Mobile`
  margin: 0 7.5px 10px 4px;
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  margin: 0 7.5px 10px 4px;
`}
  height: fill-available;
  overflow-y: auto;
  overflow-x: hidden;
`

/**
 * Styled container for individual transaction lists (pending, complete)
 */
export const StyledTransactionList = styled.div`
  padding: 0 0 5px 0;
  ${({ theme }) => theme.mediaWidth.Mobile`
   margin: 0;
  `};
`

export const HeadWrapper = styled.div`
  margin: 0 28px 5px 18px;
  ${({ theme }) => theme.mediaWidth.Mobile`
  margin: 0 28px 6px 15px
`}
  ${({ theme }) => theme.mediaWidth.Tablet`
  margin: 0 28px 6px 15px
`}
  border-top: 1px solid ${GLOBAL_COLORS.secondGrey};
  padding-top: 10px;
`

/**
 * Styled title for the list
 */
export const StyledTransactionListHeader = styled.span`
  font-size: ${TextSize.small};
  color: ${({ theme }) => theme.secondaryFontColor};
  font-weight: ${Weight.Medium};
  & > svg {
    position: relative;
    top: -4px;
  }
`

export const StyledEmptyList = styled(StyledTransactionListHeader)`
  margin-top: 10px;
  margin-bottom: 10px;
`
export const AccountContainer = styled.div`
  ${({ theme }) => theme.mediaWidth.Tablet`
  width: 100%;
    max-width: 664px;
    margin: 0 auto;
`}
`
